exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".facebook-icon {\n  margin-bottom: 5px;\n}\n\n.facebook-1{\n  fill:#1976D2;\n}\n\n.facebook-2{\n  fill:#FAFAFA;\n}", ""]);
